module.exports = __webpack_public_path__ + "static/media/OPT.c8066416.png";